import React from 'react';
import ManageUsersTabs from './ManageUsersTabs';

function ManageUsers() {
  return <ManageUsersTabs />;
}

export default ManageUsers;
